export const AS_ON = "asOn";
export const KPL = "KPL";
export const MBAPL = "MBAPL";
export const SGFL = "SGFL";
export const SIPL = "SIPL";
